<template>
  <div>
    <v-container fluid>
      <v-row align="center" justify="center" class="mx-0">
        <v-col cols="12">
          <v-card outlined min-height="110vh">
            <BackButton
              width="200"
              text="Your Business Network"
              @click="handleExitEditFormViewRegistrants"
            />
            <v-card-title class="d-flex justify-space-between">
              <div class="text-h5">{{ currentBusinessNetwork.eventName }}</div>
              <div>
                <v-btn
                  depressed
                  large
                  text
                  color="primary"
                  @click="handleDownloadQRCode"
                  >Download QR Code
                </v-btn>
                |<v-btn
                  depressed
                  large
                  @click="handleCopyLink"
                  text
                  color="primary"
                  >Copy Link
                </v-btn>
              </div>
            </v-card-title>
            <v-card-text>
              <v-tabs v-model="tab" active-class="primary--text">
                <v-tab class="text-capitalize">QR Code and Form Design</v-tab>
                <v-tab class="text-capitalize">Registrants</v-tab>
              </v-tabs>
              <v-divider />
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-col cols="6" md="6" sm="6">
                    <div class="text-subtitle-1 font-weight-bold">
                      Source/Event Name
                    </div>
                  </v-col>
                  <v-col cols="6" md="6" sm="6">
                    <v-text-field
                      v-model="currentBusinessNetwork.eventName"
                      label="Event Name"
                      outlined
                      single-line
                      hide-details
                      placeholder="Event Name"
                      dense
                      :rules="requiredRules"
                      validate-on-blur
                    />
                  </v-col>
                  <!-- <v-col cols="6" md="6" sm="6">
                    <div class="text-subtitle-1 font-weight-bold">
                      Link to your Privacy Policy
                    </div>
                    <div class="font-weight-regular">
                      Linking to your privacy policy in the submission form is
                      crucial for protecting privacy and ensuring compliance
                    </div>
                  </v-col>
                  <v-col cols="6" md="6" sm="6">
                    <v-text-field
                      v-model="currentBusinessNetwork.privacyPolicyURL"
                      label="Privacy Policy link"
                      outlined
                      single-line
                      hide-details
                      placeholder="Privacy Policy link"
                      dense
                      validate-on-blur
                      :rules="requiredRules"
                    />
                  </v-col> -->
                  <v-col cols="6" md="6" sm="6">
                    <v-row>
                      <v-col cols="6" md="6" sm="6">
                        <div class="font-weight-regular">
                          Upload a logo for your QR code
                        </div>
                      </v-col>
                    </v-row>
                    <v-sheet color="grey lighten-4" class="rounded-lg">
                      <v-row>
                        <UploadImageDialog
                          :show="showUploadImageDialog"
                          isDisplayImage
                          previewType="square"
                          @close="showUploadImageDialog = false"
                          @uploaded="handleUploaded"
                          :applyImageCompression="true"
                          ref="uploadImageDialog"
                          :isBadgeOrQrCode="true"
                          :uploadToBusinessProfile="false"
                        />
                        <v-col
                          cols="6"
                          md="6"
                          sm="6"
                          class="d-flex justify-center"
                        >
                          <div v-if="showImage === false">
                            <AddNewImage
                              @click="showUploadImageDialog = true"
                              :size="170"
                              text="Upload a logo"
                            />
                          </div>
                          <div v-else>
                            <v-hover v-slot="{ hover }">
                              <v-img
                                :src="selectedImage"
                                width="170"
                                height="170"
                                class="qr-code-image"
                              >
                                <div
                                  class="text-right mt-2 mr-2"
                                  v-show="hover"
                                >
                                  <AvatarButton
                                    icon="mdi-image"
                                    tooltipText="Change image"
                                    @click="showUploadImageDialog = true"
                                    className="d-inline-block mr-2"
                                  />

                                  <!-- <AvatarButton
                                    icon="mdi-trash-can"
                                    tooltipText="Delete image"
                                    @click="handleDeleteImage"
                                    className="d-inline-block"
                                  /> -->
                                </div>
                              </v-img>
                            </v-hover>
                          </div>
                        </v-col>
                        <v-col cols="6" md="6" sm="6">
                          <QRCode
                            ref="myQRCode"
                            :link="currentBusinessNetwork.dynamicLink"
                            :logo="selectedImage"
                            :showDownloadButton="false"
                            :size="165"
                          />
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </v-col>
                  <v-col cols="6" md="6" sm="6">
                    <v-row>
                      <v-col cols="12" md="12" sm="12">
                        <div class="font-weight-regular">
                          Select the textfield's to include in the form
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                          <div class="d-flex justify-space-between">
                            <div class="text-subtitle-1">
                              First and Last name
                            </div>
                            <div>
                              <v-switch
                                class="mt-0"
                                v-model="
                                  currentBusinessNetwork.isNameSwitchedOn
                                "
                              ></v-switch>
                            </div>
                          </div>
                          <v-divider />
                          <div v-if="currentBusinessNetwork.isNameSwitchedOn">
                            <v-radio-group
                              mandatory
                              v-model="currentBusinessNetwork.isNameRequired"
                              row
                            >
                              <v-radio
                                color="#516077"
                                :value="true"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Required"
                              ></v-radio>

                              <v-radio
                                color="#516077"
                                :value="false"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Optional"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                          <div class="d-flex justify-space-between">
                            <div class="text-subtitle-1">City</div>
                            <div>
                              <v-switch
                                class="mt-0"
                                v-model="
                                  currentBusinessNetwork.isCitySwitchedOn
                                "
                              ></v-switch>
                            </div>
                          </div>
                          <v-divider />
                          <div v-if="currentBusinessNetwork.isCitySwitchedOn">
                            <v-radio-group
                              mandatory
                              v-model="currentBusinessNetwork.isCityRequired"
                              row
                            >
                              <v-radio
                                color="#516077"
                                :value="true"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Required"
                              ></v-radio>

                              <v-radio
                                color="#516077"
                                :value="false"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Optional"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                          <div class="d-flex justify-space-between">
                            <div class="text-subtitle-1">Country</div>
                            <div>
                              <v-switch
                                class="mt-0"
                                v-model="
                                  currentBusinessNetwork.isCountrySwitchedOn
                                "
                              ></v-switch>
                            </div>
                          </div>
                          <v-divider />
                          <div
                            v-if="currentBusinessNetwork.isCountrySwitchedOn"
                          >
                            <v-radio-group
                              mandatory
                              v-model="currentBusinessNetwork.isCountryRequired"
                              row
                            >
                              <v-radio
                                color="#516077"
                                :value="true"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Required"
                              ></v-radio>

                              <v-radio
                                color="#516077"
                                :value="false"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Optional"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                          <div class="d-flex justify-space-between">
                            <div class="text-subtitle-1">Email</div>
                            <div>
                              <v-switch
                                class="mt-0"
                                v-model="
                                  currentBusinessNetwork.isEmailSwitchedOn
                                "
                              ></v-switch>
                            </div>
                          </div>
                          <v-divider />
                          <div v-if="currentBusinessNetwork.isEmailSwitchedOn">
                            <v-radio-group
                              mandatory
                              v-model="currentBusinessNetwork.isEmailRequired"
                              row
                            >
                              <v-radio
                                color="#516077"
                                :value="true"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Required"
                              ></v-radio>

                              <v-radio
                                color="#516077"
                                :value="false"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Optional"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                          <div class="d-flex justify-space-between">
                            <div class="text-subtitle-1">Mobile</div>
                            <div>
                              <v-switch
                                class="mt-0"
                                v-model="
                                  currentBusinessNetwork.isMobileSwitchedOn
                                "
                              ></v-switch>
                            </div>
                          </div>
                          <v-divider />
                          <div v-if="currentBusinessNetwork.isMobileSwitchedOn">
                            <v-radio-group
                              mandatory
                              v-model="currentBusinessNetwork.isMobileRequired"
                              row
                            >
                              <v-radio
                                color="#516077"
                                :value="true"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Required"
                              ></v-radio>

                              <v-radio
                                color="#516077"
                                :value="false"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Optional"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                          <div class="d-flex justify-space-between">
                            <div class="text-subtitle-1">Business Name</div>
                            <div>
                              <v-switch
                                class="mt-0"
                                v-model="
                                  currentBusinessNetwork.isBusinessNameSwitchedOn
                                "
                              ></v-switch>
                            </div>
                          </div>
                          <v-divider />
                          <div
                            v-if="
                              currentBusinessNetwork.isBusinessNameSwitchedOn
                            "
                          >
                            <v-radio-group
                              mandatory
                              v-model="
                                currentBusinessNetwork.isBusinessNameRequired
                              "
                              row
                            >
                              <v-radio
                                color="#516077"
                                :value="true"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Required"
                              ></v-radio>

                              <v-radio
                                color="#516077"
                                :value="false"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Optional"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                          <div class="d-flex justify-space-between">
                            <div class="text-subtitle-1">Job Title</div>
                            <div>
                              <v-switch
                                class="mt-0"
                                v-model="
                                  currentBusinessNetwork.isJobTitleSwitchedOn
                                "
                              ></v-switch>
                            </div>
                          </div>
                          <v-divider />
                          <div
                            v-if="currentBusinessNetwork.isJobTitleSwitchedOn"
                          >
                            <v-radio-group
                              mandatory
                              v-model="
                                currentBusinessNetwork.isJobTitleRequired
                              "
                              row
                            >
                              <v-radio
                                color="#516077"
                                :value="true"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Required"
                              ></v-radio>

                              <v-radio
                                color="#516077"
                                :value="false"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Optional"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                          <div class="d-flex justify-space-between">
                            <div class="text-subtitle-1">Note</div>
                            <div>
                              <v-switch
                                class="mt-0"
                                v-model="
                                  currentBusinessNetwork.isNoteSwitchedOn
                                "
                              ></v-switch>
                            </div>
                          </div>
                          <v-divider />
                          <div v-if="currentBusinessNetwork.isNoteSwitchedOn">
                            <v-radio-group
                              mandatory
                              v-model="currentBusinessNetwork.isNoteRequired"
                              row
                            >
                              <v-radio
                                color="#516077"
                                :value="true"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Required"
                              ></v-radio>

                              <v-radio
                                color="#516077"
                                :value="false"
                                off-icon="mdi-circle-outline"
                                on-icon="mdi-check-circle"
                                label="Optional"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-tab-item>
                <v-tab-item>
                  <div class="d-flex justify-space-between align-center mt-5">
                    <div class="text-subtitle-1 text-bold">
                      <v-icon>mdi-account</v-icon>
                      {{ currentBusinessNetwork.registrants.length }}
                      Registrants
                    </div>
                    <div>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          Export<v-icon text v-on="on" v-bind="attrs"
                            >mdi-chevron-down</v-icon
                          >
                        </template>
                        <v-list>
                          <v-list-item>
                            <v-list-item-title @click="handleExportPDF"
                              >Export in PDF</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title @click="handleExportCSV"
                              >Export in CSV</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>

                    <div>
                      <div>
                        <v-text-field
                          v-model="search"
                          full-width
                          append-icon="mdi-magnify"
                          label="Search for a registrant"
                          outlined
                          single-line
                          hide-details
                          rounded
                          dense
                        ></v-text-field>
                      </div>
                    </div>
                  </div>
                  <v-data-table
                    :headers="headers"
                    :search="search"
                    :items="currentBusinessNetwork.registrants"
                    :items-per-page="8"
                    :sort-by="['name']"
                  >
                    <template v-slot:[`item.firstName`]="{ item }"
                      ><p class="text-capitalize">
                        {{ item.firstName }} {{ item.lastName }}
                      </p></template
                    >
                    <template v-slot:[`item.location`]="{ item }"
                      ><p class="text-capitalize">
                        {{ item.city === "" ? "" : item.city }}
                        {{
                          item.city !== "" ? ", " + item.country : item.country
                        }}
                      </p></template
                    >

                    <template v-slot:[`item.mobile`]="{ item }"
                      >{{ item.mobile === "" ? "-" : item.mobile }}
                    </template>

                    <template v-slot:[`item.note`]="{ item }"
                      >{{ item.note === "" ? "-" : item.note }}
                    </template>

                    <template v-slot:[`item.email`]="{ item }"
                      >{{ item.email === "" ? "-" : item.email }}
                    </template>

                    <template v-slot:[`item.businessName`]="{ item }"
                      >{{ item.businessName === "" ? "-" : item.businessName }}
                    </template>

                    <template v-slot:[`item.jobTitle`]="{ item }"
                      >{{ item.jobTitle === "" ? "-" : item.jobTitle }}
                    </template>

                    <template v-slot:[`item.created`]="{ item }">
                      <span>{{
                        new Date(item.created).toLocaleDateString("en-AU")
                      }}</span>
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <v-menu
                        transition="slide-y-transition"
                        bottom
                        left
                        offset-y
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="handleRemoveRegistrant(item)">
                            <v-list-item-title>Remove</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
            <v-card-actions>
              <v-row dense class="px-3">
                <v-col cols="6" sm="6" md="6" class="text-left">
                  <v-btn
                    v-if="tab == 0"
                    width="100"
                    depressed
                    large
                    class="primary"
                    @click="handleSave"
                  >
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BackButton from "@/components/BackButton.vue";
import { mapGetters, mapActions } from "vuex";
import QRCode from "@/components/QRCode";
import AddNewImage from "@/components/AddNewImage";
import UploadImageDialog from "@/components/UploadImageDialog";
import AvatarButton from "@/components/AvatarButton";
import Utility from "@/shared/utility";
import jsPDF from "jspdf";

export default {
  components: {
    BackButton,
    AddNewImage,
    UploadImageDialog,
    QRCode,
    AvatarButton,
  },
  data() {
    return {
      id: "",
      search: "",
      tab: 0,
      unsubscribeBusinessNetworkSnapshot: null,
      showImage: true,
      requiredRules: [(v) => !!v || "This field is required"],
      showUploadImageDialog: false,
      removeRegistrantIndex: -1,
    };
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    handleExitEditFormViewRegistrants() {
      this.$router.push({ name: "YourBusinessNetwork" });
    },
    handleSave() {
      this.currentBusinessNetwork.save();
    },
    handleUploaded(downloadURL) {
      this.selectedImage = downloadURL;
      this.currentBusinessNetwork.qrCodeURL = downloadURL;
    },
    handleDeleteImage() {
      this.currentBusinessNetwork.imageURL = "";
    },
    handleRemoveRegistrant(item) {
      this.removeRegistrantIndex =
        this.currentBusinessNetwork.registrants.indexOf(item);
      this.currentBusinessNetwork.registrants.splice(
        this.removeRegistrantIndex,
        1
      );
      this.showSnackbar({ show: true, text: "Removed successfully!" });
      this.currentBusinessNetwork.save();
    },
    handleCopyLink() {
      Utility.copyToClipboard(this.currentBusinessNetwork.dynamicLink);
      this.showSnackbar({ show: true, text: "Link copied to clipboard!" });
    },
    handleDownloadQRCode() {
      this.$refs.myQRCode.downloadQRCode();
    },
    handleExportCSV() {
      const csvString = [
        [
          "Name",
          "Email",
          "Phone",
          "City",
          "Country",
          "Business Name",
          "Job Title",
          "Date Submitted",
          "Notes",
        ],
        ...this.currentBusinessNetwork.registrants.map((item) => [
          item.firstName + " " + item.lastName,
          item.email,
          item.mobile,
          item.city,
          item.country,
          item.businessName,
          item.jobTitle,
          new Date(item.created).toLocaleDateString("en-AU"),
          item.notes,
        ]),
      ]
        .map((e) => e.join(","))
        .join("\n");

      const blob = new Blob([csvString], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);

      // Creating an anchor(a) tag of HTML
      const a = document.createElement("a");

      // Passing the blob downloading url
      a.setAttribute("href", url);

      // Setting the anchor tag attribute for downloading
      // and passing the download file name
      a.setAttribute("download", "download.csv");

      // Performing a download with click
      a.click();
    },
    handleExportPDF() {
      let doc = new jsPDF({
        orientation: "p",
        format: "a4",
      });

      let registrantTableContent = "";

      this.currentBusinessNetwork.registrants.forEach((registrant) => {
        registrantTableContent +=
          "<tr>" +
          "<td>" +
          registrant.firstName +
          " " +
          registrant.lastName +
          " </td>";
        registrantTableContent +=
          "<td>" + (registrant.email !== "" ? registrant.email : "-") + "</td>";
        registrantTableContent +=
          "<td>" +
          (registrant.mobile !== "" ? registrant.mobile : "-") +
          "</td>";
        registrantTableContent +=
          "<td>" + (registrant.city !== "" ? registrant.city : "-") + "</td>";
        registrantTableContent +=
          "<td>" +
          (registrant.country !== "" ? registrant.country : "-") +
          "</td>";
        registrantTableContent +=
          "<td>" +
          (registrant.businessName !== "" ? registrant.businessName : "-") +
          "</td>";
        registrantTableContent +=
          "<td>" +
          (registrant.jobTitle !== "" ? registrant.jobTitle : "-") +
          "</td>";
        registrantTableContent +=
          "<td>" +
          new Date(registrant.created).toLocaleDateString("en-AU") +
          "</td>";
        registrantTableContent +=
          "<td>" +
          (registrant.note !== "" ? registrant.note : "-") +
          "</td></tr>";
      });

      let htmlRealString = `
      <div>
       <table style="width:100%;border-bottom:0.5px solid #ededed;">

            <tr style="text-align:left;">
             <th>Name</th>
             <th>Email</th>
             <th>Phone Number</th>
             <th>City</th>
             <th>Country</th>
             <th>Business Name</th>
             <th>Job Title </th>
             <th>Date Submitted </th>
             <th>Notes</th>
            </tr>

            ${registrantTableContent}

          </table>
      </div>
      `;

      doc.html(htmlRealString, {
        callback: function (doc) {
          doc.save("registrants.pdf");
        },
        margin: [10, 10, 10, 10],
        width: 190,
        windowWidth: 730,
      });
    },
  },
  computed: {
    ...mapGetters(["currentBusinessNetwork"]),
    headers() {
      let headerElements = [
        {
          text: "Name",
          align: "start",
          value: "firstName",
        },
        { text: "Email", value: "email", align: "start" },
        { text: "Phone Number", value: "mobile", align: "start" },
        { text: "Business Name", value: "businessName", align: "start" },
        { text: "Job Title", value: "jobTitle", align: "start" },
        { text: "Location", value: "location", align: "start" },
        { text: "Date Submitted", value: "created", align: "start" },

        { text: "Notes", value: "note", align: "start" },
      ];
      headerElements.push({
        text: "Actions",
        value: "actions",
        align: "center",
      });
      return headerElements;
    },
  },
  created() {
    this.selectedImage = this.currentBusinessNetwork.qrCodeURL;
    this.tab = this.$route.params.tab;
  },
};
</script>

<style>
</style>